import React, {useEffect, useState} from "react";
import Particles, {initParticlesEngine} from "@tsparticles/react";
import {loadFull} from "tsparticles";
import "./App.css";
import particlesOptions from "./particles.json";
//import { Link } from "react-router-dom";
import { Button } from "./Components/Button";

import '@fontsource/poppins/400.css';
import '@fontsource/poppins/700.css';

function App() {
    const [init, setInit] = useState(false);

    useEffect(() => {
        if (init) {
            return;
        }

        initParticlesEngine(async (engine) => {
            await loadFull(engine);
        }).then(() => {
            setInit(true);
        });
    }, [init]);

    return (
        <div className="App">
            {init && <Particles options={particlesOptions}/>}
            <header className="App-header">
                {/*<img src={logo} className="App-logo" alt="logo"/> */}

                <div className="circleBackground">

                    <div className="circles">
                        <div className="orbit"> <div className="ball"> </div></div>
                        <div className="orbit"> <div className="ball"> </div></div>
                        <div className="orbit"> <div className="ball"> </div></div>
                        <span></span>

                    </div>
                </div>
                
                <div className="name-block">
                    <p className="title">
                        Study<colr>Sphere</colr> Connect
                    </p>
                    <a href="https://studysphere.ca/beta">
                        <Button className="beta-button">
                            Try Beta Version
                        </Button>
                    </a>
                </div>


                <div className="home-buttons">
                  
                </div>
                
            </header>
        </div>
    );
}

export default App;
